import * as React from 'react';
import { Id, addClass } from '../../utils';
import { RadioGroupContextProvider } from './RadioGroupContext';
export class RadioGroup extends React.PureComponent {
    render() {
        const { htmlId, dataTa, className, children, onChange, value, ...rest } = this.props;
        const id = Id.create(htmlId, ['radio group']);
        return (React.createElement("div", Object.assign({ id: id.toString(), role: "radiogroup", "data-ta": dataTa, className: addClass('vai-radio-group', className) }, rest),
            React.createElement(RadioGroupContextProvider, { value: { onChange, value } }, children)));
    }
}
RadioGroup.metaProperties = [];
//# sourceMappingURL=RadioGroup.js.map